import { ExtendedProductApprovalDto, ProductSheetDto, ProductApprovalDto, ProductFormulationDto } from '../api';

export enum VerificationExistingCheckEnum {
    NOT_AVAILABLE = 'na',
    ACCEPTED = 'accepted',
    IN_PROGRESS = 'in_progress',
    REJECTED = 'rejected',
    UNDEFINED = 'undefined',
}

export enum LandingPageMode {
    INIT = 'INIT',
    UNCOMPLETE = 'UNCOMPLETE',
    UNDER_REVIEW = 'UNDER_REVIEW',
    TERMS_OF_USE = 'TERMS_OF_USE',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    MISSING_PERMISSION = 'MISSING_PERMISSION',
    UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export enum CheckColor {
    IN_PROGRESS = 'YELLOW',
    REJECTED = 'RED',
    ACCEPTED = 'GREEN',
    NONE = 'NONE',
}

export enum CookieKey {
    C_DISCLAIMER = 'c_disclaimer',
    C_TRACK_DATA = 'c_track_data',
}

export enum AdminRegistrationStepEnum {
    PLAUSIBILITY_FLUID_FINDER = 0,
    OFFER_OF_A_REWARD = 1,
    INFO_LETTER = 2,
    INVOICE = 3,
    ACTIVATION = 4,
}

export enum CompanyRegistartionStepEnum {
    TERMS_OF_USE = 0,
    UPLOAD_COMPANY_PRESENTATION = 1,
    ADDITIONAL_INFORMATION = 2,
    CHECKING_THE_INFORMATION = 3,
}

export enum CounterTypeEnum {
    returnedProcesses = 'returnedProcesses',
    drawingReleaseObligation = 'drawingReleaseObligation',
    retrieveInvoice = 'retrieveInvoice',
    uploadLabel = 'uploadLabel',
    conductAnnualReport = 'conductAnnualReport',
    thirdParty = 'thirdParty',
}

export enum FooterTabNamesEnum {
    PROVIDER = 'provider',
    LEGAL_NOTICES = 'legal_notices',
    SETTINGS = 'settings',
    DATA_PROTECTION = 'data_protection',
    COPYRIGHT_NOTICES_AND_LICENSES = 'copyright_notices_and_licenses',
}

export enum InfoLetterStateEnum {
    NONE = 'NONE',
    REQUESTED = 'REQUESTED',
    SUPPLIED = 'SUPPLIED',
}

export enum SortDirection {
    ASC = 'asc',
    DESC = 'desc',
}

export enum BStoffFileType {
    DIA4U_COMPARISON = 'DIA4U_COMPARISON',
    REAR_AXLE = 'REAR_AXLE_DIFFERENTIAL',
    FRONT_AXLE = 'FRONT_AXLE_DIFFERENTIAL',
    TRANSFER_CASE = 'TRANSFER_CASE',
    GEARBOX = 'GEARBOX',
    STEERING_GEAR = 'STEERING_GEAR',
    ENGINE_OIL = 'ENGINE_OIL',
    BRAKE_FLUID = 'BRAKE_FLUID',
    FUEL = 'FUEL',
    GREASE = 'GREASE',
    HYDRAULIC_OIL = 'HYDRAULIC_OIL',
    PRESERVATIVES = 'PRESERVATIVES',
    COMPRESSOR_OIL = 'COMPRESSOR_OIL',
    CORROSION_FROST_PROTECTION = 'CORROSION_FROST_PROTECTION',
    REFRIGERANT = 'REFRIGERANT',
    WINDSHIELD_WASHER_FLUID = 'WINDSHIELD_WASHER_FLUID',
    ELECTRIC_DRIVES = 'ELECTRIC_DRIVES',
}

export enum OilTestingEngineMasterDataTabsEnum {
    ENGINE_TYPES = 'engine_types',
    TEST_STAND = 'test_stand',
    TEST_SUBSTANCES = 'test_substances',
    INVOICE_DATA = 'invoice_data',
    TEST_BENCH_RESULTS = 'test_bench_results',
}

export enum UserDashboardMyCompany {
    MY_COMPANY = 'myCompany',
    THIRD_PARTY = 'thirdParty',
}
export enum UserServiceAreaEnum {
    DOWNLOADS_FILES = 'downloads',
    DBL_SPECIFICATIONS = 'dbl_specifications',
    FAQ = 'FAQ',
}
export enum MasterDataTabType {
    SHEETCARE = 'SHEETCARE',
    PRODUCTCARE = 'PRODUCTCARE',
    AREASCARE = 'AREASCARE',
    TESTSCARE = 'TESTSCARE',
    ADDITIVBASEOILCARE = 'ADDITIVBASEOILCARE',
}

export enum SheetCareTabOverviewTabType {
    SHEETS = 'SHEETS',
    COMPATIBLE_SHEETS = 'COMPATIBLE_SHEETS',
    OP_FLUIDS = 'OP_FLUIDS',
}

export enum ProductCareTabOverviewTabType {
    SAECLASSES = 'SAECLASSES',
    QUALITYLINES = 'QUALITYLINES',
}

export enum AreaCareTabOverviewTabType {
    CONTAINERSIZE = 'CONTAINERSIZE',
    SALESAREAS = 'SALESAREAS',
    COSTS = 'COSTS',
}

export enum TestCareTabOverviewTabType {
    COMPREHENSIVE_TESTS = 'COMPREHENSIVE_TESTS',
    RELATED_TESTS = 'RELATED_TESTS',
    SHEET_LIMITS = 'SHEET_LIMITS',
    MBSPEC = 'MBSPEC',
}

export enum AdditivBaseOilCareTabOverviewTabType {
    ADDITIVE = 'ADDITIVE',
    BASEOIL = 'BASEOIL',
    TYPE = 'TYPE',
}

export enum TestStructureType {
    TESTSTEPS = 'TESTSTEPS',
    TESTGROUPS = 'TESTGROUPS',
    TESTAREAS = 'TESTAREAS',
}

export enum TestParameterType {
    TESTPARAMETERS = 'TESTPARAMETERS',
    MANAGETESTPARAMETERS = 'MANAGETESTPARAMETERS',
}
export enum ModalTypeEnum {
    DELETE = 'Delete',
    WARNING = 'Warning',
}

export enum FileType {
    PDF = 'pdf',
    JPEG = 'jpeg',
    PNG = 'png',
    GIF = 'gif',
    DOC = 'doc',
    DOCX = 'docx',
    DOTX = 'dotx',
    PPT = 'ppt',
    PPTX = 'pptx',
}

export enum EngineOil {
    ENGINE_OIL_EN = 'Engine Oil',
    ENGINE_OIL_DE = 'Motoröl',
}

export enum GearOil {
    GEAR_OIL_DE = 'Getriebeöl',
    GEAR_OIL_EN = 'Gear Oil',
}

export enum ProcessDetailTechnicalExaminationTabType {
    GENERAL_INFORMATION = 'GENERAL_INFORMATION',
    TECHNICAL_DATA = 'TECHNICAL_DATA',
}

export enum Direction {
    TOP = 'TOP',
    LEFT = 'LEFT',
}
/**
 * Mapping of product states to their corresponding labels.
 * The keys are the various product states from different DTOs,
 * and the values are the string labels used in the application.
 * the values are the key from I18nTexts to get the translated label
 */
export const ProductStateMapping: Record<
    | ExtendedProductApprovalDto.productApprovalState
    | ProductSheetDto.productSheetState
    | ProductApprovalDto.productApprovalState
    | ProductFormulationDto.formulationState,
    string
> = {
    REQUESTED: 'requested',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    EXPIRED: 'expired',
    PENDING: 'in_progress',
    CANCELLED: 'canceled',
    NEW: 'new',
    INACTIVE: 'inactive',
    // Processes State for ExtendedProductApprovalDto 'admin'
    TECHNICAL_EXAMINATION: 'technical_examination_perform',
    RELEASE_ENGAGEMENT_CREATION: 'release_obligation_creation',
    SIGNED_RELEASE_ENGAGEMENT_MISSING: 'signed_release_obligation_missing',
    REVIEW_OF_SIGNED_RELEASE_ENGAGEMENT: 'review_of_signed_release_obligation',
    INVOICE_CREATION: 'invoice_creation',
    INVOICE_REQUESTED: 'invoice_requested',
    INVOICE_SENT: 'invoice_sent_to_customer',
    CERTIFICATE_CREATION: 'certificate_creation',
    APPROVAL_RELEASE: 'approval_release',
    INVOICE_OVERDUE: 'invoice_overdue',
    INVOICE_OPEN: 'invoice_open',
    CERTIFICATE_IN_COMPLETION: 'certificate_in_completion',
    ANNUAL_REPORT_DUE: 'annual_report_due',
    ANNUAL_REPORT_NOT_EXTENDED: 'annual_report_not_extended',
    ANNUAL_REPORT_OVERDUE: 'annual_report_overdue',
    RENEWAL_REQUIRED: 'renewal',
    RENEWAL_APPROVAL_REQUIRED: 'renewal',
    RENEWAL_APPROVAL_REQUESTED: 'requested',
    REWORK_NECESSARY: 'rework_necessary',
};
/**
 * Mapping of product states to their corresponding style classes.
 * The keys are the various product states from different DTOs,
 * and the values are the style class names used in the application.
 */
export const stateStyleMapping: Record<
    | ExtendedProductApprovalDto.productApprovalState
    | ProductSheetDto.productSheetState
    | ProductApprovalDto.productApprovalState
    | ProductFormulationDto.formulationState,
    'requested' | 'rejected' | 'approved' | 'expired' | 'cancelled' | 'draft' | 'deactivated' // Ensure these match the keys of the styles returned by useStyles
> = {
    REJECTED: 'rejected',
    APPROVED: 'approved',
    EXPIRED: 'expired',
    CANCELLED: 'cancelled',
    PENDING: 'requested',
    INVOICE_OVERDUE: 'rejected',
    REQUESTED: 'requested',
    INVOICE_OPEN: 'requested',
    NEW: 'draft',
    INACTIVE: 'deactivated',
    // Processes State for ExtendedProductApprovalDto 'admin'
    TECHNICAL_EXAMINATION: 'requested',
    RELEASE_ENGAGEMENT_CREATION: 'requested',
    SIGNED_RELEASE_ENGAGEMENT_MISSING: 'requested',
    REVIEW_OF_SIGNED_RELEASE_ENGAGEMENT: 'requested',
    INVOICE_CREATION: 'requested',
    INVOICE_REQUESTED: 'requested',
    INVOICE_SENT: 'requested',
    CERTIFICATE_CREATION: 'requested',
    APPROVAL_RELEASE: 'requested',
    CERTIFICATE_IN_COMPLETION: 'draft',
    ANNUAL_REPORT_DUE: 'requested',
    ANNUAL_REPORT_NOT_EXTENDED: 'approved',
    ANNUAL_REPORT_OVERDUE: 'rejected',
    RENEWAL_REQUIRED: 'requested',
    RENEWAL_APPROVAL_REQUIRED: 'requested',
    RENEWAL_APPROVAL_REQUESTED: 'requested',
    REWORK_NECESSARY: 'requested',
};
export enum Overview {
    ADMIN = 'ADMIN',
    MANUFACTURER = 'MANUFACTURER',
}
export enum LicenseModel {
    BEAM_FREE = 'BEAM Free',
    BEAM_FULL = 'BEAM Full',
}

export enum PublicFiles {
    TERMS_OF_USE = 'TERMS_OF_USE',
    ANNEX_ENTRANCE_FEE = 'ANNEX_ENTRANCE_FEE',
    REGISTRATION_GUIDELINES = 'REGISTRATION_GUIDELINES',
}
export enum FormulationFileTypes {
    PRODUCT_LABEL = 'PRODUCT_LABEL',
    MSDS = 'MSDS',
    EELQMS = 'EELQMS',
    DECLARATION_OF_CONSENT = 'DECLARATION_OF_CONSENT',
    THIRD_PARTY_CERTIFICATE = 'THIRD_PARTY_CERTIFICATE',
}
export enum InformationSection {
    COMPANY_INFORMATION = 'COMPANY_INFORMATION',
    ADDED_ADMIN = 'ADDED_ADMIN',
    AUTHORIZED_SIGNATORY = 'AUTHORIZED_SIGNATORY',
}
export enum ConflictReason {
    DATA_CONFLICT = 'DATA_CONFLICT',
    FILE_CONFLICT = 'FILE_CONFLICT',
}
